import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {AuthenticationService } from 'src/app/shared/services/authentication.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent  implements OnInit{
  userToken:any;
  userProfile:any={};
  imgPath:any = this.auth.apiUrl+'/uploads/';
  updateUserForm = this._formBuilder.group({
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    phone:['',[Validators.required]],
    address:['',[Validators.required]],
    zip:['',[Validators.required]],
    state:['',[Validators.required]],
    profilePic:['']
  });
  imageError:any;
  userData = new FormData();
  imgPreview:any;
  constructor(private auth:AuthenticationService , private _formBuilder:FormBuilder){}

  get updtUsr() { return this.updateUserForm.controls; }
  ngOnInit(): void {
    this.userToken = this.auth.getUserData();
    if(this.userToken._id)
    {
      this.auth.getUserProfile(this.userToken._id).subscribe((res:any)=>{
        console.log(res);
        this.imgPreview = this.imgPath+''+res.profilePic;
        this.userProfile = res;
        this.updateUserForm.get("firstName").setValue(res.firstName);
        this.updateUserForm.get("lastName").setValue(res.lastName);
        this.updateUserForm.get("phone").setValue(res.phone);
        this.updateUserForm.get("address").setValue(res.address);
        this.updateUserForm.get("zip").setValue(res.zip);
        this.updateUserForm.get("state").setValue(res.state);
      },(err:any)=>{
        console.log(err)
      })
    }
    
  }
  
  fileChangeEvent(fileInput: any) {
    this.imageError = null;
    if (fileInput.target.files && fileInput.target.files[0]) {
        // Size Filter Bytes
        const max_size = 20971520;
        const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];
        let cardImageBase64:any;
        let isImageSaved:any;

        if (fileInput.target.files[0].size > max_size) {
            this.imageError = 'Maximum size allowed is ' + max_size / 1000 + 'Mb';
            // return false;
        }
        else if (!allowed_types.includes(fileInput.target.files[0].type)) {
            this.imageError = 'Only Images are allowed ( JPG | PNG )';
            // return false;
        }
        else
        {
          console.log(fileInput.target.files)
          let files: FileList = fileInput.target.files;
          let file : File = files[0];
          this.userData.append('profilePic', files[0], files[0].name);
          const reader = new FileReader();
          reader.onload = (e: any) => {
            const image = new Image();
            image.src = e.target.result;
            image.onload = (rs:any) => {              
              const imgBase64Path = e.target.result;
              this.imgPreview = imgBase64Path;
            };
          };
        }
    }
  }
  updateUser(){
    if(this.updateUserForm.valid)
    {
      this.userData.append('firstName', this.updateUserForm.get('firstName').value);
      this.userData.append('lastName',  this.updateUserForm.get('lastName').value);
      this.userData.append('phone',  this.updateUserForm.get('phone').value);
      this.userData.append('address',  this.updateUserForm.get('address').value);
      this.userData.append('zip',  this.updateUserForm.get('zip').value);
      this.userData.append('state',  this.updateUserForm.get('state').value);
      this.auth.updateUser(this.userToken._id,this.userData).subscribe((res:any)=>{
        this.userProfile = res;
        this.imgPreview = this.imgPath+''+res.profilePic;
      },(err:any)=>{
        console.log(err);
      })
    }
  }
}

